/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, word: NonNullable<unknown> }} Profile_Editors_Pain_Intensity_MetaInputs */

const en_us2_profile_editors_pain_intensity_meta = /** @type {(inputs: Profile_Editors_Pain_Intensity_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} of 10 · ${i?.word}`)
};

const pt_br2_profile_editors_pain_intensity_meta = /** @type {(inputs: Profile_Editors_Pain_Intensity_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} de 10 · ${i?.word}`)
};

const es_419_profile_editors_pain_intensity_meta = /** @type {(inputs: Profile_Editors_Pain_Intensity_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} de 10 · ${i?.word}`)
};

const pt_pt2_profile_editors_pain_intensity_meta = /** @type {(inputs: Profile_Editors_Pain_Intensity_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} de 10 · ${i?.word}`)
};

const fr_fr2_profile_editors_pain_intensity_meta = /** @type {(inputs: Profile_Editors_Pain_Intensity_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} sur 10 · ${i?.word}`)
};

const de_de2_profile_editors_pain_intensity_meta = /** @type {(inputs: Profile_Editors_Pain_Intensity_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} von 10 · ${i?.word}`)
};

const it_it2_profile_editors_pain_intensity_meta = /** @type {(inputs: Profile_Editors_Pain_Intensity_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} su 10 · ${i?.word}`)
};

/**
* | output |
* | --- |
* | "{n} of 10 · {word}" |
*
* @param {Profile_Editors_Pain_Intensity_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_intensity_meta = /** @type {((inputs: Profile_Editors_Pain_Intensity_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Intensity_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_intensity_meta(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_intensity_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_intensity_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_intensity_meta(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_intensity_meta(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_intensity_meta(inputs)
	return en_us2_profile_editors_pain_intensity_meta(inputs)
});
export { profile_editors_pain_intensity_meta as "profile-editors.pain_intensity_meta" }